var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496.8 496.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M152,484c0,6.4-5.6,12-12,12l0,0c-6.4,0-12-5.6-12-12V12c0-6.4,5.6-12,12-12l0,0c6.4,0,12,5.6,12,12 V484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M138.4,0L138.4,0c7.2,0,13.6,5.6,13.6,12.8V484c0,7.2-6.4,12.8-12.8,12.8l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M208,484c0,6.4-5.6,12-12,12l0,0c-6.4,0-12-5.6-12-12V12c0-6.4,5.6-12,12-12l0,0c6.4,0,12,5.6,12,12 V484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M194.4,0L194.4,0c6.4,0,13.6,5.6,13.6,12.8V484c0,7.2-6.4,12.8-13.6,12.8l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M312,484c0,6.4-5.6,12-12,12l0,0c-6.4,0-12-5.6-12-12V12c0-6.4,5.6-12,12-12l0,0c6.4,0,12,5.6,12,12 V484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M301.6,0L301.6,0C308,0,312,5.6,312,12.8V484c0,7.2-4.8,12.8-12,12.8l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M368,484c0,6.4-5.6,12-12,12l0,0c-6.4,0-12-5.6-12-12V12c0-6.4,5.6-12,12-12l0,0c6.4,0,12,5.6,12,12 V484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M356.8,0L356.8,0C364,0,368,5.6,368,12.8V484c0,7.2-4.8,12.8-12,12.8l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M260,484c0,6.4-5.6,12-12,12l0,0c-6.4,0-12-5.6-12-12V12c0-6.4,5.6-12,12-12l0,0c6.4,0,12,5.6,12,12 V484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M248.8,0L248.8,0C256,0,260,5.6,260,12.8V484c0,7.2-4.8,12.8-12,12.8l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M12.8,152C5.6,152,0,147.2,0,140l0,0c0-7.2,5.6-12,12.8-12H484c7.2,0,12.8,4.8,12.8,12l0,0 c0,7.2-5.6,12-12.8,12H12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M496,138.4L496,138.4c0,7.2-5.6,13.6-12.8,13.6H12.8C5.6,152,0,145.6,0,139.2l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M496,196c0,6.4-5.6,12-12,12H12c-6.4,0-12-5.6-12-12l0,0c0-6.4,5.6-12,12-12h472 C490.4,184,496,189.6,496,196L496,196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M496,194.4L496,194.4c0,7.2-5.6,13.6-12.8,13.6H12.8C5.6,208,0,201.6,0,194.4l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M496,300c0,6.4-5.6,12-12,12H12c-6.4,0-12-5.6-12-12l0,0c0-6.4,5.6-12,12-12h472 C490.4,288,496,293.6,496,300L496,300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M496,301.6L496,301.6c0,7.2-5.6,10.4-12.8,10.4H12.8C5.6,312,0,307.2,0,300l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M496,252c0,6.4-5.6,12-12,12H12c-6.4,0-12-5.6-12-12l0,0c0-6.4,5.6-12,12-12h472 C490.4,240,496,245.6,496,252L496,252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M496,253.6L496,253.6c0,7.2-5.6,10.4-12.8,10.4H12.8C5.6,264,0,259.2,0,252l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M12.8,368C5.6,368,0,363.2,0,356l0,0c0-7.2,5.6-12,12.8-12H484c7.2,0,12.8,4.8,12.8,12l0,0 c0,7.2-5.6,12-12.8,12H12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M496,356.8L496,356.8c0,7.2-5.6,11.2-12.8,11.2H12.8C5.6,368,0,363.2,0,356l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#363F3E"
    },
    d: "M408,381.6c0,14.4-12,26.4-26.4,26.4H122.4C108,408,96,396,96,381.6V122.4C96,108,108,96,122.4,96 h259.2c14.4,0,26.4,12,26.4,26.4V381.6z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96,122.4C96,108,108,96,122.4,96h259.2c14.4,0,26.4,12,26.4,26.4v259.2c0,14.4-12,26.4-26.4,26.4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495150"
    },
    d: "M352,335.2c0,9.6-7.2,16.8-16.8,16.8H168.8c-9.6,0-16.8-7.2-16.8-16.8V168.8 c0-9.6,7.2-16.8,16.8-16.8h166.4c9.6,0,16.8,7.2,16.8,16.8V335.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#393F3E"
    },
    d: "M152,168.8c0-9.6,7.2-16.8,16.8-16.8h166.4c9.6,0,16.8,7.2,16.8,16.8v166.4c0,9.6-7.2,16.8-16.8,16.8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC113"
    },
    d: "M317.6,256H312v-58.4c0-2.4-4.8-5.6-7.2-5.6h-13.6c-1.6,0-2.4,1.6-3.2,2.4L248,252 c-3.2-16-15.2-25.6-32-25.6c-5.6,0-11.2,1.6-16,4c4.8-10.4,14.4-17.6,26.4-19.2c3.2-0.8,6.4-0.8,8.8-0.8c0.8,0,2.4,0,3.2-0.8 s1.6-1.6,1.6-3.2V196c0-2.4-2.4-4-4-4c-3.2,0-6.4,0-10.4,0.8c-12.8,1.6-24,7.2-32.8,15.2c-11.2,11.2-17.6,27.2-17.6,45.6 c0,26.4,15.2,44.8,37.6,44.8c19.2,0,30.4-12,34.4-27.2l0.8,0.8h40v20.8c0,2.4,2.4,3.2,4.8,3.2h12c2.4,0,7.2-0.8,7.2-3.2V272h6.4 c2.4,0,1.6-3.2,1.6-4.8v-8.8C320,256,319.2,256,317.6,256z M268.8,256l19.2-28.8c0-0.8,0-2.4,0-3.2l0,0v32H268.8z M228,261.6 c0,11.2-5.6,19.2-14.4,19.2c-15.2,0-16.8-18.4-16.8-23.2c0-1.6,0-2.4,0.8-4c3.2-5.6,8.8-9.6,15.2-9.6 C222.4,243.2,228,250.4,228,261.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M317.6,256H312v-58.4c0-2.4-4.8-5.6-7.2-5.6h-13.6c-1.6,0-2.4,1.6-3.2,2.4L248,252 c-3.2-16-15.2-25.6-32-25.6c-2.4,0-4,0.8-6.4,1.6l44,44.8H288v20.8c0,2.4,2.4,3.2,4.8,3.2h14.4c2.4,0,4.8-0.8,4.8-3.2V272h6.4 c2.4,0,1.6-3.2,1.6-4.8v-8.8C320,256,319.2,256,317.6,256z M288,224.8V256h-19.2l19.2-28.8V224.8L288,224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A615"
    },
    d: "M235.2,210.4c0.8,0,2.4,0,3.2-0.8s1.6-1.6,1.6-3.2V196c0-2.4-2.4-4-4-4c-3.2,0-6.4,0-10.4,0.8 c-12.8,1.6-24,7.2-32.8,15.2l-0.8,0.8l13.6,13.6c5.6-5.6,12.8-9.6,20.8-11.2C229.6,210.4,232.8,210.4,235.2,210.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArm);
export default __webpack_public_path__ + "static/media/ARM.78d45400cf9c59562d772066ccb4768e.svg";
export { ForwardRef as ReactComponent };